import React, { useEffect } from "react"
// import { Link } from "react-router-dom"

import Banner from "../components/banner"
// import PageTitle from "../components/pageTitle"
import Footer from "../components/footer"

const Error = () => {
  useEffect(() => {
    document.title = "Error 404 - Page Not found"
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="media-page error">
      <Banner bannerClass="error-banner"></Banner>
      {/* <PageTitle
        title="Page Not Found"
        subtitle="The page you are looking for is down or not available"
      >
        <div className="btns">
          <Link to="/" className="btn btn-primary">
            Go back home
          </Link>
        </div>
      </PageTitle> */}
      <main className="404-error">
        <div className="container">
          <h1
            style={{
              fontSize: "200px",
            }}
          >
            404
          </h1>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Error
